import React from 'react';
import { useManageLogs } from '../contexts/manage-logs.context';
import { O2OCustomPaging } from 'o2o_layout';

const PaginationPrivacyLogs = () => {
  const { searchPlatformTermUser } = useManageLogs();

  return (
    <O2OCustomPaging
      list={searchPlatformTermUser?.response as never}
      onChange={(e: number) => searchPlatformTermUser?.handleOnChangeCriteria({ page: e })}
      onChangePageSize={(e: number) => searchPlatformTermUser?.handleOnChangeCriteria({ page: 0, pageSize: e })}
    />
  );
};

export default PaginationPrivacyLogs;
